import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { formatMoney } from "@/lib/format";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("currency_mode") || "crore");

  useEffect(() => {
    localStorage.setItem("currency_mode", mode);
  }, [mode]);

  const money = useCallback((value, opts) => formatMoney(value, mode, opts), [mode]);

  return (
    <CurrencyContext.Provider value={{ mode, setMode, money }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
